import { createSelector } from 'reselect'

export const getEula = state => state.eulaReducer.eula.eula
export const getEulaHash = state => state.eulaReducer.eula.hash
export const isEulaBeingFetched = state => state.eulaReducer.eula.fetching

export const isEulaOk = createSelector(
    [getEula, isEulaBeingFetched],
    (eula, fetching) => {
        if (fetching) return false
        if (eula === '') return false
        return true
    },
)



// WEBPACK FOOTER //
// ./src/features/Eula/data/eula/selectors.js